import { render, staticRenderFns } from "./document.vue?vue&type=template&id=3a30b705&"
import script from "./document.vue?vue&type=script&lang=ts&"
export * from "./document.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports